import React from 'react';
import { PropTypes } from 'prop-types';

import StepNavigation from '../StepNavigation';
import Slide from '../Slide';

import CarouselNavigationButtons, { ButtonTypes } from '../CarouselNavigationButtons';

const CaseStudiesContent = ({
    styles,
    rules,
    type,
    slides,
    activeIndex,
    moveToNextSlide,
    width,
    transitionDuration,
    isMoving,
    moveToNextSlideMobile,
    moveToSlideId,
    handleHover,
}) => {
    return (
        <>
            <StepNavigation
                moveToSlideId={moveToSlideId}
                type={type}
                slides={slides}
                currentSlide={activeIndex}
                nextSlide={moveToNextSlide}
                handleHover={handleHover}
                extend={{ container: rules.stepNavigationContainer }}
            />
            <div className={styles.container}>
                {slides.map((slide, index) => {
                    return (
                        <Slide
                            heading={slide.heading}
                            subHeading={slide.subHeading}
                            tags={slide.tags}
                            link={slide.link}
                            key={slide.id}
                            width={width}
                            slidesCount={slides.length}
                            isMoving={isMoving}
                            transitionDuration={transitionDuration}
                            reference={slide.reference}
                            deviceImage={slide.deviceImage}
                            deviceAlt={slide.deviceAlt}
                            deviceType={slide.deviceType}
                            mainImage={slide.mainImage}
                            moveToNextSlide={moveToNextSlide}
                            moveToNextSlideMobile={moveToNextSlideMobile}
                            isActive={activeIndex === index}
                            mainImageActive={activeIndex === index}
                            isLast={slides.length - 1 === index}
                            logo={slide.logo}
                        />
                    );
                })}
            </div>

            <CarouselNavigationButtons
                {...{
                    moveToSlideId,
                    activeIndex,
                    type: ButtonTypes.LIGHT,
                    extend: {
                        navigationContainer: rules.navigationContainer,
                        navigationButton: rules.navigationButton,
                    },
                }}
            />
        </>
    );
};

CaseStudiesContent.propTypes = {
    styles: PropTypes.shape().isRequired,
    theme: PropTypes.shape().isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    width: PropTypes.number.isRequired,
    transitionDuration: PropTypes.number.isRequired,
    translate: PropTypes.number.isRequired,
    isMoving: PropTypes.bool.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    activeIndex: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    moveToSlideId: PropTypes.func.isRequired,
    handleHover: PropTypes.func,
};

export default CaseStudiesContent;
